import { useTranslation } from "react-i18next";
import { useTheme, type ThemePreference } from "../theme/theme-context";

const OPTIONS: { value: ThemePreference; icon: string; labelKey: string }[] = [
  { value: "light", icon: "pi pi-sun", labelKey: "ui.themeLight" },
  { value: "dark", icon: "pi pi-moon", labelKey: "ui.themeDark" },
];

/** Light and dark only; light is the default. */
export default function ThemeToggle() {
  const { t } = useTranslation();
  const { preference, setPreference } = useTheme();

  return (
    <div className="seg" role="radiogroup" aria-label={t("ui.theme")}>
      {OPTIONS.map((opt) => {
        const label = t(opt.labelKey);
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={preference === opt.value}
            aria-label={label}
            title={label}
            className="seg__btn"
            onClick={() => setPreference(opt.value)}
          >
            <i className={opt.icon} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
